module.exports = __webpack_public_path__ + "static/media/gradient-close.d332248a.svg";